module.exports = __webpack_public_path__ + "fonts/lato-v17-latin-700.874b8e7.woff";